import $ from 'jquery';
import Headroom from 'headroom.js';

// Headroom settings
const settings = {
  // vertical offset in px before element is first unpinned
  offset: 115,
  // scroll tolerance in px before state changes
  tolerance: 5, // or {down: 0, up: 0},
  // css classes to apply
  classes: {
    // when element is initialised
    initial: 'headroom',
    // when scrolling up
    pinned: 'locked',
    // when scrolling down
    unpinned: 'unlocked',
    // when above offset
    top: 'top',
    // when below offset
    notTop: 'not-top',
    // when at bottom of scoll area
    bottom: 'bottom',
    // when not at bottom of scroll area
    notBottom: 'not-bottom',
  },
  // callback when pinned, `this` is headroom object
  onPin() {},
  // callback when unpinned, `this` is headroom object
  onUnpin() {},
  // callback when above offset, `this` is headroom object
  onTop() {},
  // callback when below offset, `this` is headroom object
  onNotTop() {},
  // callback at bottom of page, `this` is headroom object
  onBottom() {},
  // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom() {},
};

function Header(element) {
  this.element = element;
  this.$element = $(element);
  // Create a new Headroom instance
  this.headroom = new Headroom(element, settings);
  // Add listeners
  this.addListeners();
  // Initialize this Headroom instance
  this.headroom.init();
}

Header.prototype = {
  closeHandler(event) {
    if ($(event.target).is('.page-header')) {
      $(document.body).removeClass('menu-active search-active');
    }
  },
  addListeners() {
    this.$element.on('click', this.closeHandler);
  },
};

export default Header;



// WEBPACK FOOTER //
// ./Header.js